import { createSlice } from "@reduxjs/toolkit";
import { createMessageBuilder } from "./builder";

const initialState = {
  message: {
    newMessage: "",
    loading: false,
    error: null,
  },
};

export const messagesSlice = createSlice({
  name: "messagesInfo",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    createMessageBuilder(builder);
    builder.addCase("logout", () => ({ ...initialState, loggedIn: false }));
  },
});

// export const {} = messagesSlice.actions;

export const selectMessage = (state) => state.messagesInfo.message;

export default messagesSlice.reducer;
